export default __webpack_public_path__ + "static/media/File_download.cda502e4.svg";